import { ReactNode } from "react";
import { ScrollView, View } from "react-native";

type NewsListScrollableProps = Readonly<{
  children: ReactNode;
  maxHeight?: number;
}>;

export default function NewsListScrollable({
  children,
  maxHeight,
}: NewsListScrollableProps) {
  return (
    <View
      style={maxHeight !== undefined ? { maxHeight, flex: 1 } : { flex: 1 }}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ gap: 8 }}
      >
        {children}
      </ScrollView>
    </View>
  );
}
